<!--监控面版-->
<template>
  <div id="showTrans" ></div>
</template>

<script>
  import config from "cnetong-core-frontend/base/config";

  let chartDefaultData = {
    // 图形大小
    linePointShow: true,// 线上的点 动不动
    ontPeriod:5,// 第一个点的移动速度
    twoPeriod:7,// 第二个点的移动速度
    symbolSizeClient:[80,40],// 客户端大小
    symbolSizeClient_:[80,40],// 客户端大小
    // 图形字颜色
    lableColorClient:"#000000",
    lableColorClient_:"#ff0000",
    // 提示
    clientTitle : "运行正常",
  };

import EnvironmentApi from "@/api/dashboardmgr/EnvironmentApi";

export default {
  data() {
    return {
      clientName:"数据交换客户端",
      // 初始化高给800 动态根据连接数量会动态计算
      divHeight:"height:1000px;",
      localArrData:[{"name":"IBMMQ","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":true,"csstat":true,"havepd":true,"pdstat":true},
        {"name":"RabbitMQ1","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":false,"csstat":true,"havepd":true,"pdstat":true},
        {"name":"FTP","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":true,"csstat":true,"havepd":false,"pdstat":true},
        {"name":"AS","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":true,"csstat":true,"havepd":true,"pdstat":true}],
      transArrData:[{"name":"IBMMQ","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":false,"csstat":true,"havepd":true,"pdstat":true},
        {"name":"RabbitMQ","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":true,"csstat":true,"havepd":true,"pdstat":true},
        {"name":"FTP","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":true,"csstat":true,"havepd":true,"pdstat":true},
        {"name":"AS","connconf": {"host":"192.168.2.1"},"connstat":true,"havecs":true,"csstat":true,"havepd":false,"pdstat":true}],
      chart:Object.assign({}, chartDefaultData),
      // 异常数量
      exceptions:0,
      // 阻塞数量
      blocknum:0,
      // 警告数量
      warnnum:0,
      t1: "",
      t2 : "",
      linksData : [],
      coordsData:[],
    };
  },
  destroyed() {
    this.clearInterfval();
  },
  watch: {
    // 系统出现异常和阻塞就自动去检测一下
    exceptions: function() {
      EnvironmentApi.doQueryStatus().then(resp=>{
        this.localArrData = resp.localArrData;
        this.transArrData = resp.transArrData;
      }).then(()=>{
        var lg = this.localArrData.length;
        if(this.localArrData.length<this.transArrData.length){
          lg = this.transArrData.length;
        }
        this.setShowTransHeight(lg);
        this.drawLine()
      });
    },
    blocknum: function() {
      EnvironmentApi.doQueryStatus().then(resp=>{
        this.localArrData = resp.localArrData;
        this.transArrData = resp.transArrData;
      }).then(()=>{
        var lg = this.localArrData.length;
        if(this.localArrData.length<this.transArrData.length){
          lg = this.transArrData.length;
        }
        this.setShowTransHeight(lg);
        this.drawLine()
      });
    },
  },
  mounted() {
      EnvironmentApi.doQuery().then(resp=>{
        this.localArrData = resp.localArrData;
        this.transArrData = resp.transArrData;
      }).then(()=>{
        var lg = this.localArrData.length;
        if(this.localArrData.length<this.transArrData.length){
          lg = this.transArrData.length;
        }
        this.setShowTransHeight(lg);
        this.drawLine()
      });
      this.notification();
      // 启动定时器 变化大小
      this.startInterfval();
  },
  methods: {
    setShowTransHeight(lg){
      var minHeihth = document.body.scrollHeight-150;
      var hight = lg*100+200;
      if(hight<minHeihth){
        hight=minHeihth
      }
      document.getElementById("showTrans").style.cssText="height:"+hight+"px;";
    },
    getChartLinksData(source,target){
      var json = {};
      json.source = source;
      json.target = target;
      json.lineStyle = { color: "#12b5d0" };
      this.linksData.push(json);
    },
    getChartCoordsData(source,target){
      var json = {};
      json.coords = [source,target];
      this.coordsData.push(json);
    },
    getEchartData(){
      var jsonstr = [];
      this.linksData = [];
      this.coordsData = [];
      jsonstr = this.getEchartClientData(jsonstr);
      jsonstr = this.getEchartLocalData(jsonstr);
      jsonstr = this.getEchartTransData(jsonstr);

      return jsonstr;
    },
    getEchartClientData(jsonstr){
      var lg = this.localArrData.length;
      if(this.localArrData.length<this.transArrData.length){
        lg = this.transArrData.length;
      }
        var json = {};
        json.name = this.clientName;
        // 客户端鼠标悬停描述

        json.value=[500, 100*lg+50]
        json.fixed=false,
        json.symbol= 'image://data:image/png;base64,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'
        // 出现异常时 大小等于变量
        if(this.exceptions>0){
          json.symbolSize= [110, 95]
          json.tooltip={ formatter: "异常数量："+this.exceptions }
          json.label={
            color: this.chart.lableColorClient_,
            position: 'bottom',
          }
        }else{
          json.symbolSize= [90, 80]
          json.tooltip={ formatter: this.chart.clientTitle }
          json.label={
            color: this.chart.lableColorClient,
            position: 'bottom',
          }
        }
        json.category=1,
        jsonstr.push(json);
        return jsonstr;
    },
    getEchartLocalData(jsonstr){
      var clientlg = this.localArrData.length;
      if(this.localArrData.length<this.transArrData.length){
        clientlg = this.transArrData.length;
      }
      var lg = this.localArrData.length;
      for(var i=0;i<this.localArrData.length;i++){
          var json = {};
          json.name = "本地侧："+this.localArrData[i].name;
          json.value=[250, 200*(lg-i)-50]
          json.fixed=false,
          json.symbol='image://data:image/png;base64,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'
          if(!this.localArrData[i].connstat){
            json.symbolSize= [95,75]
            json.tooltip={ formatter: this.localArrData[i].conninfo};
            json.label={
              color: this.chart.lableColorClient_,
              position: 'bottom',
            }
          }else{
            json.symbolSize= [80,60]
            json.tooltip={ formatter: this.chart.clientTitle }
            json.label={
              color: this.chart.lableColorClient,
              position: 'bottom',
            }
          }
        json.category=1,
        jsonstr.push(json);
        if(this.localArrData[i].havecs){
          jsonstr = this.getEchartLocalResData(jsonstr,this.localArrData[i],json.name,"0",250,200*(lg-i)-50);
          this.getChartCoordsData(json.value,[500, 100*clientlg+50]);
          this.getChartLinksData(json.name,this.clientName);
        }
        if(this.localArrData[i].havepd){
          jsonstr = this.getEchartLocalResData(jsonstr,this.localArrData[i],json.name,"1",250,200*(lg-i)-50);
          this.getChartCoordsData([500, 100*clientlg+50],json.value);
          this.getChartLinksData(this.clientName,json.name);
        }
      }
      return jsonstr;
  },
    getEchartLocalResData(jsonstr,data,name,type,x,y){
      var json = {};
      if(type==='0'){
        json.name = name+"-发送资源";
        json.value=[0, y+50]
        this.getChartLinksData(json.name,name);
        this.getChartCoordsData(json.value,[x,y]);
        if(!data.csstat){
          json.symbolSize= [85,75]
          json.tooltip={ formatter: data.csinfo}
          json.label={
            color: this.chart.lableColorClient_,
            position: 'bottom',
          }
        }else{
          json.symbolSize= [70,60]
          json.tooltip={ formatter: this.chart.clientTitle }
          json.label={
            color: this.chart.lableColorClient,
            position: 'bottom',
          }
        }
        json.symbol= 'image://data:image/png;base64,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'
      }else{
        json.name = name+"-接收资源";
        json.value=[0, y-50]
        this.getChartLinksData(name,json.name);
        this.getChartCoordsData([x,y],json.value);
        if(!data.csstat){
          json.symbolSize= [85,75]
          json.tooltip={ formatter: data.pdinfo}
          json.label={
            color: this.chart.lableColorClient_,
            position: 'bottom',
          }
        }else{
          json.symbolSize= [70,60]
          json.tooltip={ formatter: this.chart.clientTitle }
          json.label={
            color: this.chart.lableColorClient,
            position: 'bottom',
          }
        }
        json.symbol= 'image://data:image/png;base64,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'
      }
      json.fixed=false,
      json.category=1,
      jsonstr.push(json);
      return jsonstr;
    },
    getEchartTransResData(jsonstr,data,name,type,x,y){
      var json = {};
      if(type==='0'){
        json.name = name+"-接收资源";
        json.value=[1000, y-50],
        this.getChartLinksData(json.name,name);
        this.getChartCoordsData(json.value,[x,y]);
        if(!data.csstat){
          json.symbolSize= [85,75]
          json.tooltip={ formatter: data.csinfo };
          json.label={
            color: this.chart.lableColorClient_,
            position: 'bottom',
          }
        }else{
          json.symbolSize= [70,60]
          json.tooltip={ formatter: this.chart.clientTitle }
          json.label={
            color: this.chart.lableColorClient,
            position: 'bottom',
          }
        }
        json.symbol= 'image://data:image/png;base64,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'
      }else{
        json.name = name+"-发送资源";
        json.value=[1000, y+50]
        this.getChartLinksData(name,json.name);
        this.getChartCoordsData([x,y],json.value);
        if(!data.csstat){
          json.symbolSize= [85,75]
          json.tooltip={ formatter: data.pdinfo };
          json.label={
            color: this.chart.lableColorClient_,
            position: 'bottom',
          }
        }else{
          json.symbolSize= [70,60]
          json.tooltip={ formatter: this.chart.clientTitle }
          json.label={
            color: this.chart.lableColorClient,
            position: 'bottom',
          }
        }
        json.symbol= 'image://data:image/png;base64,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'
      }

        json.fixed=false,
        json.category=1,
        jsonstr.push(json);
      return jsonstr;
    },
    getEchartTransData(jsonstr){
      var clientlg = this.localArrData.length;
      if(this.localArrData.length<this.transArrData.length){
        clientlg = this.transArrData.length;
      }
      var lg = this.transArrData.length;
      for(var i=0;i<this.transArrData.length;i++){
        var json = {};
        json.name = "传输侧："+this.transArrData[i].name;
        json.value=[750, 200*(lg-i)-50]
        json.fixed=false,
          json.symbol= 'image://data:image/png;base64,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'
          if(!this.transArrData[i].connstat){
            json.symbolSize= [95,75]
            json.tooltip={ formatter: this.transArrData[i].conninfo };
            json.label={
              color: this.chart.lableColorClient_,
              position: 'bottom',
            }
          }else{
            json.symbolSize=  [80,60]
            json.tooltip={ formatter: this.chart.clientTitle };
            json.label={
              color: this.chart.lableColorClient,
              position: 'bottom',
            }
          }
          json.category=1,
          jsonstr.push(json);
        if(this.transArrData[i].havecs){
          jsonstr = this.getEchartTransResData(jsonstr,this.transArrData[i],json.name,"0",750,200*(lg-i)-50);
          this.getChartLinksData(json.name,this.clientName);
          this.getChartCoordsData(json.value,[500, 100*clientlg+50]);
        }
        if(this.transArrData[i].havepd){
          jsonstr = this.getEchartTransResData(jsonstr,this.transArrData[i],json.name,"1",750,200*(lg-i)-50);
          this.getChartLinksData(this.clientName,json.name);
          this.getChartCoordsData([500, 100*clientlg+50],json.value);
        }
      }
      return jsonstr;
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.charts = this.$echarts.init(document.getElementById('showTrans'));
      // 绘制图表
      this.charts.setOption({
        xAxis: {
          show: false,
          type: "value"
        },
        yAxis: {
          show: false,
          type: "value"
        },
        tooltip: {},
        series: [{
          type: "graph",
          zlevel: 5,
          draggable: false,
          coordinateSystem: "cartesian2d", //使用二维的直角坐标系（也称笛卡尔坐标系）
          symbol: "rect",
          symbolOffset: ["15%", 0],

          label: {
            normal: {
              show: true
            }
          },
          data:this.getEchartData(),
          links: this.linksData,
          lineStyle: {
            normal: {
              opacity: 1,
              color: "#53B5EA",
              curveness: 0.2,
              // 12b5d0
              // type: "dashed",
              width: 2
            }
          }
        },
          {
            type: "lines",
            coordinateSystem: "cartesian2d",
            z: 1,
            zlevel: 2,
            animation: false,
            effect: {
              show: this.chart.linePointShow,
              period: this.chart.ontPeriod, // 移动速度
              trailLength: 0.01, // 点的长度
              symbolSize: 12, // 点的大小
              symbol: "pin",
              loop: true,
              color: "rgba(55,155,255,0.5)"
            },
            lineStyle: {
              normal: {
                color: "#22AC38",
                width: 0,
                curveness: 0.2
              }
            },
            data:this.coordsData,
          },
          {
            type: "lines",
            coordinateSystem: "cartesian2d",
            z: 1,
            zlevel: 2,
            animation: false,
            effect: {
              show: this.chart.linePointShow,
              period: this.chart.twoPeriod,
              trailLength: 0.01,
              symbolSize: 12,
              symbol: "pin",
              loop: true,
              color: "rgba(55,155,255,0.5)"
            },
            lineStyle: {
              normal: {
                color: "#22AC38",
                width: 0,
                curveness: 0.2
              }
            },
            data:this.coordsData,
          },
        ]
      });
    },
    // -------------------------------websocket---------------------------------
    notification() {
      // const wsurl = "ws://" + this.host + ":" + this.port + "/asemonitor";
      // const wsurl = "ws://127.0.0.1:9099/asemonitor";
      let wsurl_;
      if (process.env.NODE_ENV === 'production') {
        wsurl_ = `ws://${config.context.domain}:${config.context.port}/asemonitor`;
      } else {
        wsurl_ = `ws://localhost:9099/asemonitor`;
      }
      const wsurl = wsurl_;
      this.notice = new WebSocket(wsurl);
      this.notice.onmessage  = function(e) {
        const redata = JSON.parse(e.data);
        if (redata.wstype === "ws07") {
          if (redata.errors > 0) {
            this.exceptions = redata.errors;
          } else {
            this.exceptions = 0;
          }
          if (redata.blocks > 0) {
            this.blocknum =  redata.blocks;
          } else {
            this.blocknum =  0;
          }
        } else if (redata.wstype === "ws09") {
          if (redata.dxpreswarn > 0) {
            this.warnnum = redata.dxpreswarn;
          } else {
            this.warnnum = 0;
          }
        }
      }.bind(this);
      this.notice.onclose = this.websocketclose;
    },
    websocketclose(e) {
      // 关闭
      console.log("connection closed (" + e.code + ")");
    },
    // 启动定时器
    startInterfval(){
      this.t1 = setInterval(() => {
        this.chart.symbolSizeClient_=[100,50]
        this.drawLine();
        this.t2 = setTimeout(() => {
          this.chart.symbolSizeClient_=[80,40]
          this.drawLine();
        }, 500)
      }, 1000)
    },
    // 清除定时任务
    clearInterfval(){
      clearInterval(this.t1);
      clearTimeout(this.t2);
    },
  }
};
</script>

<style lang="scss" >
  #showTrans{
    background:url('showtrans_bg.jpg');
    background-size: cover;
  }
</style>
